import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; governance_modules: number; traceability_sources: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; every_recommendation_explainable: boolean; complete_lineage: boolean;
  evidence_complete: boolean; governance_approval: boolean; risk_assessment_complete: boolean;
  transparency_coverage_complete: boolean; gaps?: string[];
};

export type Gov001Status = {
  sprint_id: string; objectives: number; governance_modules: number; traceability_sources: number;
  ai_governance: boolean; explainability: boolean; evidence_graph: boolean;
  certification: boolean; risk_assessment: boolean; transparency: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const aiGovernanceGov001Api = {
  dashboard: () => fetchG<SprintDashboard>('/gov001/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/gov001/objectives').then((r) => r.objectives),
  governanceModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/gov001/governance-modules').then((r) => r.modules),
  traceabilitySources: () => fetchG<{ sources: { key: string; name: string; category: string }[] }>('/gov001/traceability-sources').then((r) => r.sources),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/gov001/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/gov001/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/gov001/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/gov001/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Gov001Status>('/gov001/status'),
};
